import { createSlice } from "@reduxjs/toolkit";

const initialState = []

export const newRoofSlice = createSlice({
  name: "status",
  initialState: initialState,
  reducers: {
    updateStatusInfo: (state, action) => {
      return action.payload;
    },
  },
});

export const { updateStatusInfo } = newRoofSlice.actions;

export default newRoofSlice.reducer;
